export const RU_LOCALE = "ru-RU";
export const PANELS = {
  DAYS: "days",
  MONTHS: "months",
  YEARS: "years",
} as const;
